/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */


$(function(){
  
  var date = new Date().now
  function getCart() {
    $.getJSON('/cart.js?time=' + Date.now(), function (cart, textStatus) {
      console.log(cart)
      $('.Header__CartCount').text(cart.item_count)
    });
  }
  getCart();
  
  
  if (window.performance && window.performance.navigation.type === window.performance.navigation.TYPE_BACK_FORWARD) {
    getCart();
    
    window.adev = false
    console.log(window.adev)
    
    document.documentElement.dispatchEvent(new CustomEvent('product:added', {
      bubbles: true,
      detail: {
        variant: 121,
        quantity: 1
      }
    }));
    
    window.adev = true
    console.log(window.adev)
  }
  
})